import {assoc, not} from 'ramda'

import {FormReducer} from 'state/reducers/form'

export const submitForm: FormReducer = (state) => assoc('submitted', not(state.submitted), state)
